import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ContentFeedDrawerType} from '../../contentFeeds.store.types';

interface ContentFeedDrawerState {
  isDrawerOpen: boolean;
  drawerType: ContentFeedDrawerType | null;
}

const contentFeedDrawerInitialState: ContentFeedDrawerState = {
  isDrawerOpen: false,
  drawerType: null,
};

const contentFeedDrawerSlice = createSlice({
  name: 'contentFeedDrawer',
  initialState: contentFeedDrawerInitialState,
  reducers: {
    openDrawer: (state, action: PayloadAction<{drawerType: ContentFeedDrawerType}>) => {
      state.isDrawerOpen = true;
      state.drawerType = action.payload.drawerType;
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false;
      state.drawerType = null;
    },
  },
});

export const {openDrawer, closeDrawer} = contentFeedDrawerSlice.actions;
export default contentFeedDrawerSlice.reducer;
